import { render, staticRenderFns } from "./AddDisable.vue?vue&type=template&id=2f4c045e&scoped=true&"
import script from "./AddDisable.vue?vue&type=script&lang=js&"
export * from "./AddDisable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4c045e",
  null
  
)

export default component.exports